import React from 'react';
import { changeLang, Lang } from '../../../states/query';
import { useTranslation } from 'react-i18next';
import TermsBodyJP from './TermsBodyJP';
import TermsBodyEN from './TermsBodyEN';

const TermsBody: React.FC = () => {
  const { i18n } = useTranslation();
  const lang = changeLang(i18n.language);
  switch(lang) {
    case Lang.ja: return <TermsBodyJP/>
    case Lang.en: return <TermsBodyEN/>
  }
}

export default TermsBody;
